import { Box, Card, CardProps, Inset } from "@radix-ui/themes";

export function Root({ children, ...props }: CardProps) {
  return (
    <Card size="2" {...props} className="woswidgets-card-list">
      <Inset side="all" clip="padding-box">
        {children}
      </Inset>
    </Card>
  );
}

export function Item({ children }: { children: React.ReactNode }) {
  return (
    <Inset
      side="x"
      px="current"
      className="woswidgets-card-list-item"
      clip="padding-box"
    >
      <Box px="4" py="4">
        {children}
      </Box>
    </Inset>
  );
}
